import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Deal } from './deal.model';
import { ModelService } from '../../../shared/services/model.service';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable()
export class DealService extends ModelService<Deal> {
    protected urlPath = '/deal';

    constructor(http: ApiHttpClient) {
        super(http);
    }

    dealsForBorrower(borrowerId: number): Observable<Deal[]> {
        const params = {
            query:  JSON.stringify({
                'criteria': {
                    'deals.borrowerId': {'==': borrowerId }
                }
            })
        };
        return this.http.get<any[]>('/deal', { params }).pipe(
            map(deals => deals.map(this.createFromResponseData))
        );
    }

    protected createFromResponseData(responseData: any): Deal {
        return new Deal(responseData);
    }

}
